import React, {Component} from 'react';
import axios from "axios";
import {MuiPickersUtilsProvider, DateTimePicker} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import frLocale from "date-fns/locale/fr";
import { parse } from 'date-fns'

import AuthService from "../../AuthService";


class ExtraDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            result: null,
            data: {},
            formData: {
                croisiereExtra: {
                    id: null,
                    croisiere: {
                        id: this.props.croisiereId
                    },
                    label: "",
                    amount: "",
                    amountFloat: ""
                }
            }
        }

        this.change = this.change.bind(this);
        this.changePrice = this.changePrice.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        if (!!this.props.croisiereExtraId) {
            await axios.post(AuthService.getUrl('/getCrosisereExtra'), {
                croisiereExtra: {
                    id: this.props.croisiereExtraId
                }
            }, AuthService.getAuthHeader()).then(res => {
                this.setState({
                    result: res.data.return,
                    data: res.data.data
                });
                this.setState(state => {
                    const formData = state.formData;
                    res.data.data.croisiereExtra.amountFloat = res.data.data.croisiereExtra.amount / 100;
                    formData.croisiereExtra = res.data.data.croisiereExtra;
                    return {formData : formData};
                });
            });
        }
    }

    change(e) {
        let target = e.target;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereExtra[target.name] = target.value;
            return {formData : formData};
        });
    }

    changePrice(e) {
        let target = e.target;
        this.setState(state => {
            const formData = state.formData;
            formData.croisiereExtra.amountFloat = target.value.replace(",", ".");
            formData.croisiereExtra.amount = Number(formData.croisiereExtra.amountFloat) * 100;
            return {formData : formData};
        });
    }

    async submit(e) {
        e.preventDefault();
        const data = {
            croisiereExtra: {}
        };

        if (this.state.formData.croisiereExtra.id) {
            data.croisiereExtra.id = this.state.formData.croisiereExtra.id;
        }
        data.croisiereExtra.label = this.state.formData.croisiereExtra.label;
        data.croisiereExtra.amount = this.state.formData.croisiereExtra.amount;
        data.croisiereExtra.amountFloat = this.state.formData.croisiereExtra.amountFloat;
        data.croisiereExtra.croisiere = {id: this.props.croisiereId};
        await axios.post(AuthService.getUrl('/saveCroisiereExtra'), data, AuthService.getAuthHeader()).then(res => {
            if (res.errorMessage) {
                this.props.closeDialog(e, null, res.data.errorMessage);
            } else {
                this.props.closeDialog(e, res.data.validMessage, null);
            }
        });
    }

    async delete(croisiereExtraId) {
        await axios.post(AuthService.getUrl('/deleteCroisiereExtra'), {id: croisiereExtraId}, AuthService.getAuthHeader()).then(res => {
            if (res.errorMessage) {
                this.props.closeDialog(null, null, res.data.errorMessage);
            } else {
                this.props.closeDialog(null, res.data.validMessage, null);
            }
        });
    }

    render() {
        return (
            <div id="processDialog">
                <div className="dialogTitle">Facturation extra</div>
                <form id="processDialogForm" onSubmit={e => this.submit(e)}>
                    <div className="line">
                        <div className="label">Label</div>
                        <input type="text" className="value"
                               name="label" value={this.state.formData.croisiereExtra.label}
                               onChange={this.change}/>
                    </div>
                    <div className="line">
                        <div className="label">Montant</div>
                        <input type="text" className="value"
                               name="amountFloat" value={this.state.formData.croisiereExtra.amountFloat}
                               onChange={this.changePrice}/>
                    </div>
                    <div className="line" style={{justifyContent: "space-around"}}>
                        {!!this.props.croisiereExtraId &&
                            <button type="button" className="validButton" onClick={() => this.delete(this.props.croisiereExtraId)}>Supprimer</button>
                        }
                        <button type="submit" className="validButton" disabled={!this.state.formData.croisiereExtra.label || !this.state.formData.croisiereExtra.amountFloat}>Valider</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default ExtraDialog;
